import axios from 'axios';

export default (document_id) =>
  axios.get(`${process.env.VUE_APP_API_ENDPOINT}/document-manager/download/${document_id}`);
